import React from "react";

export default class Request extends React.Component {
  static getZwwConfig() {
    return {
      // 政务网配置
      // zwwcom:"http://10.12.23.141:8081", //（测试）
      zwwcom: "https://zwfw.nmg.gov.cn", //（生产）
      //登录
      zwwlogin: "/sso/sso/login",
      //退出
      zwwlogout: "/sso/sso/logout",
      //注册
      zwwRegister: "/sso/register",
      //退出后的返回地址
      logouttourl: "https://tyjrswt.nmg.gov.cn/tyjrmh/entrance/home",
      //登录后重定向的地址
      devredirectUrl: "http://yhbest.imwork.net:36002/sso",
      prodredirectUrl: "https://tyjrswt.nmg.gov.cn/tyjrmh/sso",
      // clientId:"VC8PFDJ2N"
      clientId: "DKOETXSRS",
    };
  }
  //DebugUrl URL
  static getDebugUrl() {
    return "/tyjrmh/api/";
  }

  // static getPhotoUrl() {
  //   // return "http://192.168.1.68:8084/dj_web/consultation/photoDownload.do?fileName="
  //   return "http://web.nndj.gov.cn/dj_web/consultation/photoDownload.do?fileName=";
  // }

  // static getPhotoUpload(){
  //    return this.getDebugUrl() + "dj_web/app/appGrzx.action";
  // }
  static getInfo() {
    return this.getDebugUrl() + "blade-affairs/serviceitem/detail";
  }

  static logout() {
    return this.getDebugUrl() + "blade-auth/oauth/logout";
  }

  static getUserEncryption() {
    return (
      this.getDebugUrl() + "blade-system/applicationmanag/sso/getUserEncryption"
    );
  }
  //注册
  static getRegister() {
    return this.getDebugUrl() + "blade-portal/registerserver/register";
  }
  //退役军人注册
  static getSoldier() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybveteranspersonalinformationform/register"
    );
  }
  //登录
  static getLogin() {
    return this.getDebugUrl() + "blade-auth/oauth/token";
  }
  //短信验证码登录
  static getSmsLogin() {
    // return this.getDebugUrl() + "swsmart-portal/registerserver/verifyIdentity";
    // return this.getDebugUrl() + "blade-auth/oauth/token";
  }
  //忘记密码
  static forgotPasswordAndReset() {
    return this.getDebugUrl() + "blade-portal/index/forgotPasswordAndReset";
  }

  //获取验证码
  static getVerificationCode() {
    return this.getDebugUrl() + "blade-auth/oauth/captcha";
  }
  //登录双重认证短信验证码
  static getMfaSms() {
    return this.getDebugUrl() + "blade-auth/oauth/sms-captcha-mfa";
  }
  //获取短信验证码
  static getverifyIdentity() {
    return this.getDebugUrl() + "blade-portal/registerserver/getSmsCode";
  }
  // 首页banner图
  static getPagehomebanner() {
    return this.getDebugUrl() + "blade-portal/index/pagehomebanner";
  }

  // 首页政策法规列表
  static getPoliciesRegulations() {
    return this.getDebugUrl() + "blade-portal/index/getPoliciesRegulations";
  }

  // 二维码图片接口
  static getQrcodeInfo() {
    return this.getDebugUrl() + "blade-portal/index/qrcodeInfo";
  }

  // 门户底部信息接口
  static getPagehomeBottonInfo() {
    return this.getDebugUrl() + "blade-portal/index/pagehomeBottonInfo";
  }

  //退役军人-个人中心-个人信息详情-未提交认证
  static userInfo() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybveteranspersonalinformationform/detail"
    );
  }
  //退役军人-个人中心-个人信息详情-已提交认证
  static userInfo1() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybveteranspersonalinformationformapply/detail"
    );
  }
  //退役军人-个人中心-用户信息认证
  static userInfoAuth() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybveteranspersonalinformationformapply/authentication"
    );
  }
  //退役军人-个人中心-用户信息更新
  static userInfoUpdate() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybveteranspersonalinformationformapply/update"
    );
  }

  //退役军人-个人中心-异地培训资金结算-申请
  static settlementApplicationAdd() {
    return this.getDebugUrl() + "blade-job-startup/sybauditcapitalapply/insert";
  }
  //退役军人-个人中心-异地培训资金结算-详情
  static settlementApplicationDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybauditcapitalapply/detail";
  }
  //退役军人-个人中心-异地培训资金结算-更新
  static settlementApplicationUpdate() {
    return this.getDebugUrl() + "blade-job-startup/sybauditcapitalapply/update";
  }
  //退役军人-个人中心-异地培训资金结算-删除
  static settlementApplicationDeleted() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybauditcapitalapply/deleted"
    );
  }
  //退役军人-个人中心-异地培训资金结算-列表
  static settlementApplicationList() {
    return this.getDebugUrl() + "blade-job-startup/sybauditcapitalapply/list";
  }
  //退役军人-个人中心-创业基地入驻记录-列表
  static entrepreneurshipBaseRecordsList() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybapplicationsettlebaseapply/list"
    );
  }
  //退役军人-个人中心-创业基地入驻记录-详情
  static entrepreneurshipBaseRecordsDetail() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybapplicationsettlebaseapply/detail"
    );
  }
  //退役军人-个人中心-创业基地入驻记录-更新
  static entrepreneurshipBaseRecordsUpdate() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybapplicationsettlebaseapply/update"
    );
  }
  //退役军人-个人中心-创业基地入驻记录-重新审核
  static entrepreneurshipBaseRecordsReInsert() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybapplicationsettlebaseapply/insert"
    );
  }
  //退役军人-个人中心-创业基地入驻记录-删除
  static entrepreneurshipBaseRecordsDelete() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybapplicationsettlebaseapply/delete"
    );
  }

  //招聘企业-机构中心-机构信息详情-未提交认证
  static institutionInfo() {
    return this.getDebugUrl() + "blade-job-startup/sybauditmechanism/detail";
  }
  //招聘企业-机构中心-机构信息详情-已提交认证
  static institutionInfo1() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybauditmechanismapply/detail"
    );
  }
  //招聘企业-机构中心-机构信息更新
  static institutionInfoUpdate() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybauditmechanismapply/update"
    );
  }
  //招聘企业-机构中心-机构信息认证
  static institutionInfoAuth() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybauditmechanismapply/authentication"
    );
  }
  //招聘企业-机构中心-人才储备库-人才列表
  static talentList() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/personnel/page"
    );
  }
  //招聘企业-机构中心-人才储备库-收藏到人才储备库
  static collection() {
    return this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/save";
  }
  //招聘企业-机构中心-人才储备库-取消收藏到人才储备库
  static cancelCollection() {
    return this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/remove";
  }
  //招聘企业-机构中心-人才储备库-简历详情
  static resumeDetails() {
    return this.getDebugUrl() + "blade-job-startup/sybresumeinformation/detail";
  }
  //招聘企业-机构中心-简历签约管理-分页
  static resumeSigningList() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/signing/page"
    );
  }
  //招聘企业-机构中心-收到的简历-设置标签
  static resumeSetLabel() {
    return this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/set/label";
  }
  //创业帮扶----创业服务申请列表
  static serveList() {
    return this.getDebugUrl() + "blade-job-startup/sybepalservice/list";
  }
  //金融产品
  static moneyList() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybauditmechanism/getAllFinanceUnit"
    );
  }
  //创业帮扶----创业服务申请
  static serveList() {
    return this.getDebugUrl() + "blade-job-startup/sybepalservice/list";
  }
  //创业帮扶----创业服务申请----详情
  static serveListDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybepalservice/detail";
  }
  //创业帮扶----创业专家
  static specialist() {
    return this.getDebugUrl() + "blade-job-startup/sybepalexpert/list";
  }
  //创业帮扶----创业专家详情
  static specialistDetails() {
    return this.getDebugUrl() + "blade-job-startup/sybepalexpert/detail";
  }
  //创业帮扶----创业专家详情----创业巡诊
  static specialistDetailsMake() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybepalexpertinquiryapply/insert"
    );
  }
  //创业帮扶----创业金融服务
  static financialList() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/helpList"
    );
  }
  //创业帮扶----创业金融服务-----详情
  static financialDetail() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/detail"
    );
  }
  //创业帮扶----创业金融服务-----新增
  static financialAdd() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/insert";
  }
  //创业帮扶----创业金融服务基金
  static financialBaseList() {
    return this.getDebugUrl() + "blade-job-startup/sybfunddetail/list";
  }
  //创业帮扶----创业金融服务基金----详情
  static financialBaseDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybfunddetail/detail";
  }
  static newFinancialBaseDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybfunddetail/detail";
  }

  //创业帮扶----创业金融服务基金----详情---申请
  static financialBaseApply() {
    return this.getDebugUrl() + "blade-job-startup/sybfundapply/save";
  }
  static financialBaseApplyNew() {
    return this.getDebugUrl() + "/blade-job-startup/sybfundapply/save";
  }
  //创业帮扶----创业基地列表
  static startBaseList() {
    return this.getDebugUrl() + "blade-job-startup/sybepalbase/list";
  }
  //创业帮扶----创业基地----详情
  static startBaseDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybepalbase/detail";
  }
  //创业帮扶----创业基地----详情
  static startBaseApply() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybapplicationsettlebaseapply/insert"
    );
  }
  //就业招聘----职位详情
  static jobDetailsData() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/recruit/detail"
    );
  } //就业招聘----企业详情
  static companyDetails() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/unit/detail"
    );
  } //就业招聘----企业详情列表
  static companyDetailList() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybjobinformationapply/unit/page"
    );
  } //就业招聘----首页列表
  static listDetails() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/recruit/page"
    );
  }

  //首页 热招岗位
  static homeJobList() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/home/jobList"
    );
  }
  //就业招聘----列表收藏
  static collectList() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/collectible"
    );
  } //就业招聘----取消收藏
  static cancelCollectList() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/cancel/collectible"
    );
  } //就业招聘----投递简历
  static sendOnesResume() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybjobinformationapply/delivery"
    );
  } //个人中心----简历投递
  static personageResume() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybresumemanageform/page/delivery/records"
    );
  }
  //个人中心----简历管理
  static resumeManagement() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybresumeinformation/user/detail"
    );
  } //个人中心----收到简历详情
  static receiveResumeDetails() {
    return this.getDebugUrl() + "blade-job-startup/sybresumeinformation/detail";
  } //个人中心----简历新增
  static addResume() {
    return this.getDebugUrl() + "blade-job-startup/sybresumeinformation/save";
  } //个人中心----收到的简历
  static receiveResume() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/received/page"
    );
  } //个人中心----简历搜索
  static searchResume() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/search/page"
    );
  } //个人中心----收到的简历---添加到人才储备库
  static addTalents() {
    return this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/save";
  } //个人中心----收到的简历---取消人才储备库
  static cancelTalents() {
    return this.getDebugUrl() + "blade-job-startup/sybtalentpoolform/remove";
  }

  //用户中心账户信息修改保存
  static updatePersonalUser() {
    return this.getDebugUrl() + "blade-portal/personaluser/updatePersonalUser";
  }

  //用户中心账户管理实名认证详情
  static personalUserAuthDetail() {
    return (
      this.getDebugUrl() + "blade-portal/personaluser/personalUserAuthDetail"
    );
  }

  //用户中心账户管理实名认证详情
  static updatePersonalUserAuth() {
    return this.getDebugUrl() + "blade-portal/personaluser/personalUserAuth";
  }

  //用户中心修改密码
  static updatePassword() {
    return this.getDebugUrl() + "blade-portal/personaluser/updatePassword";
  }

  //用户中心订单列表
  static personalUserOrders() {
    return this.getDebugUrl() + "blade-portal/personaluser/personalUserOrders";
  }
  //用户中心订单详情
  static personalUserOrderDetails() {
    return this.getDebugUrl() + "blade-portal/personaluser/getOrderDetail";
  }
  //用户中心取消订单
  static personalUserRemoveOrder() {
    return this.getDebugUrl() + "blade-portal/personaluser/removeOrder";
  }
  //用户中心收藏列表
  static personalUserCollect() {
    return this.getDebugUrl() + "blade-portal/personaluser/personalFavorite";
  }

  //用户中心删除收藏
  static personalUserDelCollect() {
    return this.getDebugUrl() + "blade-portal/personaluser/removeFavorite";
  }

  //动态咨询
  static getDynamicInfo() {
    return this.getDebugUrl() + "blade-portal/dyinformation/list";
  }

  //动态咨询文章详情
  static articleDetail() {
    return this.getDebugUrl() + "blade-portal/articleUtils/detail";
  }

  //动态咨询附件信息
  static articleAttachment() {
    return this.getDebugUrl() + "blade-portal/articleUtils/getArticleAnnex";
  }

  //获取省市
  static getArea() {
    return this.getDebugUrl() + "blade-portal/registerserver/cityList";
  }

  //获取政策信息
  static getPolicyInfo() {
    return this.getDebugUrl() + "blade-portal/policiesRegulations/list";
  }

  //查询前后文章
  static getArticleLink() {
    return this.getDebugUrl() + "blade-portal/articleUtils/getNextAndBefore";
  }

  //全文检索
  static searchByParam() {
    return this.getDebugUrl() + "swsmartsearch/search/searchByParam";
  }

  //附件下载
  static AttachmentDownload() {
    return this.getDebugUrl() + "blade-portal/articleUtils/downloadSingFile";
  }

  //地市查询
  static getAreaTree() {
    return this.getDebugUrl() + "swsmartsystem/dept/areaTree";
  }

  //关于我们
  static aboutUs() {
    return this.getDebugUrl() + "blade-portal/aboutus/list";
  }
  //军旅文化
  static soldier() {
    return this.getDebugUrl() + "blade-portal/military/list";
  }
  //优惠服务列表
  static getPreferentialServiceList() {
    return (
      this.getDebugUrl() +
      "blade-portal/preferentialProducts/getPreferentialServiceList"
    );
  }
  //公益服务列表
  static soldigetWelfareServiceLister() {
    return (
      this.getDebugUrl() +
      "blade-portal/preferentialProducts/getWelfareServiceList"
    );
  }
  //获得产品信息
  static selectProductNameAndValue() {
    return (
      this.getDebugUrl() +
      "blade-portal/preferentialProducts/selectProductNameAndValue"
    );
  }
  //获得平台准则
  static getPing() {
    return this.getDebugUrl() + "blade-portal/articleUtils/getPing";
  }
  //收藏或取消产品
  static saveOrRemoveFavorite() {
    return (
      this.getDebugUrl() +
      "blade-portal/preferentialProducts/saveOrRemoveFavorite"
    );
  }
  //取消收藏
  static removeFavorite() {
    return (
      this.getDebugUrl() + "blade-portal/preferentialProducts/removeFavorite"
    );
  }
  //预约/下订单
  static saveOrder() {
    return this.getDebugUrl() + "blade-portal/preferentialProducts/saveOrder";
  }
  //获得产品分类
  static getProductType() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/getProductType"
    );
  }

  //服务商修改信息
  static submitPrviderInformation() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/submitPrviderInformation"
    );
  }

  //服务商获取详情
  static detailProviderInformation() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/detailProviderInformation"
    );
  }

  //服务商修改密码
  static serviceUpdateUserPassword() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/updateUserPassword"
    );
  }

  //服务商订单列表
  static serviceGetOrders() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/getOrderList"
    );
  }
  //服务商产品列表
  static serviceGetProductList() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/getProductList"
    );
  }
  //服务商完成订单服务
  static updateOrder() {
    return (
      this.getDebugUrl() + "blade-portal/serviceProviderInformation/updateOrder"
    );
  }
  //审核撤回
  static chectReturn() {
    return (
      this.getDebugUrl() + "blade-portal/serviceProviderInformation/chectReturn"
    );
  }
  //上下架产品
  static changStatus() {
    return (
      this.getDebugUrl() + "blade-portal/serviceProviderInformation/changStatus"
    );
  }
  //删除产品
  static removeProduct() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/removeProduct"
    );
  }
  //根据产品类型获得产品属性
  static getTypeNameList() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/getTypeNameList"
    );
  }
  //发布产品
  static saveProduct() {
    return (
      this.getDebugUrl() + "blade-portal/serviceProviderInformation/saveProduct"
    );
  }
  //服务商产品信息
  static selectServiceProductNameAndValue() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/selectProductNameAndValue"
    );
  }
  //修改服务商产品信息
  static updateProductPropertyValue() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/updateProductPropertyValue"
    );
  }
  //查询审核列表
  static getAuditRecordList() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/getAuditRecordList"
    );
  }
  //服务商统计分析
  static statisticalAnalysis() {
    return (
      this.getDebugUrl() +
      "blade-portal/serviceProviderInformation/statisticalAnalysis"
    );
  }

  //优抚首页banner
  static getArticleBannerList() {
    return (
      this.getDebugUrl() + "blade-portal/thisApplication/articleBannerList"
    );
  }

  //优抚事项
  static getItemsList() {
    return this.getDebugUrl() + "blade-portal/thisApplication/itemsList";
  }

  //优抚事项详情
  static getItemsDetail() {
    return this.getDebugUrl() + "blade-portal/thisApplication/itemsDetail";
  }

  //优抚政策，资讯列表
  static getArticlelist() {
    return this.getDebugUrl() + "blade-portal/thisApplication/articlelist";
  }

  //优抚申请-获取档案信息
  static getArchivalInformation() {
    return this.getDebugUrl() + "blade-portal/thisApplication/verifyFile";
  }

  //优抚申请-申请类型-一级
  static getApplicationTypeOne() {
    return this.getDebugUrl() + "blade-portal/thisApplication/applicationType";
  }
  //优抚申请-申请类型-二级
  static getApplicationTypeTwo() {
    return this.getDebugUrl() + "blade-portal/thisApplication/applicationType";
  }
  //优抚申请-申请类型-三级
  static getApplicationTypeThree() {
    return this.getDebugUrl() + "blade-portal/thisApplication/applicationType";
  }

  //优抚申请-提交
  static getSaveApplication() {
    return this.getDebugUrl() + "blade-portal/thisApplication/saveApplication";
  }

  //富文本配置
  static getUeditorConfig() {
    return this.getDebugUrl() + "swsmartcms/ueditorConfig";
  }
  static geteUploadfile() {
    return this.getDebugUrl() + "swsmartcms/ueditorUpload";
  }

  //首页
  static getHome() {
    return this.getDebugUrl() + "blade-affairs/serviceitem/list";
  }

  static getServiceManageList() {
    return this.getDebugUrl() + "blade-affairs/servicemanage/list";
  }

  static getNewHome() {
    return (
      this.getDebugUrl() +
      "blade-affairs/servicemanage/gatewayServiceManageVOList"
    );
  }

  static getEvent() {
    return this.getDebugUrl() + "blade-affairs/serviceitem/list";
  }

  static getEventDetail() {
    return this.getDebugUrl() + "blade-affairs/serviceitem/detail";
  }

  static get_Bm_Ts() {
    return this.getDebugUrl() + "blade-cms/cmsbanner/clicktree";
  }

  //类别
  static get_dict() {
    return this.getDebugUrl() + "blade-system/dict/list";
  }
  //获取字典
  static get_allDict() {
    return this.getDebugUrl() + "blade-system/dict/dictionary";
  }
  //投诉建议
  static getComplaint() {
    return this.getDebugUrl() + "blade-affairs/omscomplaint/list";
  }
  static getProcessList() {
    return (
      this.getDebugUrl() +
      "blade-affairs/itemcaseregisterinfo/selectGatewayProgressMonitoringList"
    );
  }
  static getComplaintDetail() {
    return this.getDebugUrl() + "blade-affairs/omscomplaint/detail";
  }
  static saveComplaint() {
    return this.getDebugUrl() + "blade-affairs/omscomplaint/save";
  }

  //获取地区下拉
  static allCityList() {
    return this.getDebugUrl() + "swsmart-system/org/cityTree";
  }

  static getOrgTree() {
    return this.getDebugUrl() + "swsmart-system/dept/deptTreeList";
  }

  static getArticle() {
    return this.getDebugUrl() + "swsmart-cms/cmsarticle/page";
  }
  // static getBanner(){
  //   return this.getDebugUrl() + "blade-cms/cmsbanner/page";
  // }
  static detailModel() {
    return this.getDebugUrl() + "blade-cms/cmspage/detail";
  }
  static detailSinglePage(id) {
    return this.getDebugUrl() + `blade-cms/cmspage/page/${id}`;
  }

  static detailUser() {
    return this.getDebugUrl() + "blade-user/getDetail";
  }

  static saveUserInfo() {
    return this.getDebugUrl() + "blade-user/updateDetail";
  }

  //智能客服
  static getProblems() {
    return (
      this.getDebugUrl() + "blade-affairs/customerserviceproblem/labelList"
    );
  }
  static getAnswer() {
    return this.getDebugUrl() + "blade-affairs/customerserviceanswer/list";
  }
  static getInputAnswer() {
    return (
      this.getDebugUrl() +
      "blade-affairs/customerserviceproblem/userProblemList"
    );
  }
  static getAnswerClass() {
    return (
      this.getDebugUrl() +
      "blade-affairs/customerserviceclassification/classificationList"
    );
  }

  // 互动交流
  // /swsmart-auth/oauth/captcha
  static getVeriCode() {
    // 获取验证码
    return this.getDebugUrl() + "blade-auth/oauth/captcha";
  }

  static saveOmbMsg() {
    // 网上征求意见箱新增
    return (
      this.getDebugUrl() + "blade-affairs/interactiveconsultationmailbox/save"
    );
  }
  static saveDmbMsg() {
    // 厅长信箱新增
    return this.getDebugUrl() + "blade-affairs/interactivedirectormailbox/save";
  }
  static saveSoMsg() {
    // 征求意见新增
    return this.getDebugUrl() + "blade-affairs/interactivesolicitopinions/save";
  }
  static saveBcMsg() {
    // 业务咨询新增
    return (
      this.getDebugUrl() + "blade-affairs/interactivebusinessconsulting/save"
    );
  }

  static isTuiYi() {
    // 验证退役军人
    return (
      this.getDebugUrl() +
      "blade-comprehensive/tbtyidentity/selectJudgingVeterans"
    );
  }

  // 业务咨询
  static businessonsultingDetail() {
    return (
      this.getDebugUrl() + "blade-affairs/interactivebusinessconsulting/detail"
    );
  }

  static businessconsultingLList() {
    return (
      this.getDebugUrl() + "blade-affairs/interactivebusinessconsulting/list"
    );
  }

  // 厅长信箱
  static directormailboxDetail() {
    return (
      this.getDebugUrl() + "blade-affairs/interactivedirectormailbox/detail"
    );
  }

  static directormailboxLList() {
    return this.getDebugUrl() + "blade-affairs/interactivedirectormailbox/list";
  }

  // 征求意见
  static solicitopinionsDetail() {
    return (
      this.getDebugUrl() + "blade-affairs/interactivesolicitopinions/detail"
    );
  }

  static solicitopinionsLList() {
    return this.getDebugUrl() + "blade-affairs/interactivesolicitopinions/list";
  }
  // 网上征求意见
  static consultationmailboxDetail() {
    return (
      this.getDebugUrl() + "blade-affairs/interactiveconsultationmailbox/detail"
    );
  }

  static consultationmailboxLList() {
    return (
      this.getDebugUrl() + "blade-affairs/interactiveconsultationmailbox/list"
    );
  }

  static getOfficArea() {
    return this.getDebugUrl() + "blade-affairs/servicestationmanage/list";
  }
  //个人中心评价
  static getEvaluate() {
    return this.getDebugUrl() + "/swsmart-affairs/itemcaseregisterinfo/update";
  }
  //获取当前地址栏指定参数
  static GetUrlParam(paraName) {
    var url = document.location.toString(); //获取当前地址栏url
    var arrObj = url.split("?");
    if (arrObj.length > 1) {
      var arrPara = arrObj[1].split("&");
      var arr;
      for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");
        if (arr != null && arr[0] == paraName) {
          return arr[1];
        }
      }
      return "";
    } else {
      return "";
    }
  }
  //教育培训列表数据
  static getEduList() {
    // return this.getDebugUrl() + "blade-job-startup/educationandtraining/page";
    return (
      this.getDebugUrl() + "/blade-job-startup/sybtracoursesdetail/helpList"
    );
  }
  //教育培训分类
  static getTraList() {
    return this.getDebugUrl() + "blade-job-startup/educationandtraining/list";
  }
  //教育培训详情
  static eduDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybtracoursesdetail/detail";
  }
  //线下课程报名
  static getApply() {
    return (
      this.getDebugUrl() + "blade-job-startup/educationandtraining/application"
    );
  }
  //技能培训记录列表
  static getRecordList() {
    return this.getDebugUrl() + "blade-job-startup/sybaudittrainapply/list";
  }
  //技能培训记录新增
  static recordAdd() {
    return this.getDebugUrl() + "blade-job-startup/sybaudittrainapply/insert";
  }
  //技能培训记录详情
  static getRecordDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybaudittrainapply/detail";
  }
  //技能培训记录修改
  static recordUpdate() {
    return this.getDebugUrl() + "blade-job-startup/sybaudittrainapply/update";
  }
  //技能培训记录删除
  static recordDelete() {
    return this.getDebugUrl() + "blade-job-startup/sybaudittrainapply/deleted";
  }
  //申请创业服务
  static applyFor() {
    return this.getDebugUrl() + "blade-job-startup/sybepalservicesapply/save";
  }
  //申请培训记录列表
  static applyForRecord() {
    return this.getDebugUrl() + "blade-job-startup/sybapplicationform/page";
  }
  //申请培训记录详情
  static applyForRecordDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybapplicationform/detail";
  }
  //课程学习记录评价
  static applyForRecordEvaluate() {
    return this.getDebugUrl() + "blade-job-startup/sybcoursecomment/insert";
  }
  //课程新增
  static addTeach() {
    return this.getDebugUrl() + "blade-job-startup/sybtracoursesdetail/insert";
  }
  //线下课程详情
  static teachDetal() {
    return this.getDebugUrl() + "blade-job-startup/sybtracoursesdetail/detail";
  }
  //线下课程修改
  static updateDetal() {
    return this.getDebugUrl() + "blade-job-startup/sybtracoursesdetail/update";
  }
  //线下课程列表
  static getInlineTeachList() {
    return this.getDebugUrl() + "blade-job-startup/sybtracoursesdetail/list";
  }

  //课程记录列表分页
  static getSubjectRecordList() {
    return this.getDebugUrl() + "blade-job-startup/sybcourserecord/list";
  }

  //课程记录详情
  static getSubjectRecordDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybcourserecord/detail";
  }

  //课程评价记录列表分页
  static getSubjectEvaluationList() {
    return this.getDebugUrl() + "/blade-job-startup/sybcoursecomment/list";
  }
  //培训机构课程评价记录列表分页
  static getTrainSubjectEvaluationList() {
    return this.getDebugUrl() + "/blade-job-startup/sybcoursecomment/list";
  }
  //培训机构课程评价记录详情
  static getTrainSubjectDetail() {
    return (
      this, this.getDebugUrl() + "blade-job-startup/sybcoursecomment/detail"
    );
  }

  //发布新职位
  static publishNewJob() {
    return this.getDebugUrl() + "blade-job-startup/sybjobinformationapply/save";
  }
  //职位修改（不管什么状态 修改之后都为提交（审批中））
  static updateJob() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybjobinformationapply/update"
    );
  }
  //获取职位列表
  static getJobList() {
    return this.getDebugUrl() + "blade-job-startup/sybjobinformationapply/page";
  }
  //职位删除
  static deliteJob() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybjobinformationapply/remove"
    );
  }
  //获取岗位详情
  static getJobDetail() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybjobinformationapply/detail"
    );
  }
  //职位开启
  static getJobOpen() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/publishing/open"
    );
  }
  //职位关闭
  static getJobClose() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/publishing/shut"
    );
  }
  //获取地区下拉
  static getCityList() {
    return this.getDebugUrl() + "blade-system/org/cityTree";
  }
  //获取行业下拉框
  static getHanyList() {
    return this.getDebugUrl() + "blade-job-startup/educationandtraining/list";
  }
  //获取招聘会列表
  static getJobFairList() {
    return this.getDebugUrl() + "blade-job-startup/sybjobfairmanage/list";
  }
  //获取招聘会详情
  static getJobFairDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybjobfairmanage/detail";
  }
  //其他注册
  static otherRegister() {
    return this.getDebugUrl() + "blade-job-startup/sybauditmechanism/register";
  }
  //修改密码
  static changePwd() {
    return this.getDebugUrl() + "blade-user/eamsUpdatePassword";
  }
  //获取字典
  static getDictionaries() {
    return this.getDebugUrl() + "blade-job-startup/sybdict/selectList";
  }
  //获取新字典
  static getNewDict() {
    // return this.getDebugUrl() + "blade-system/dict-biz/tree";
    return this.getDebugUrl() + "blade-system/dict-biz/list";
  }

  //金融机构
  // 金融产品详情表接口  分页接口
  static getFinancialProductListNew() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/list";
  }
  //新增金融产品
  // static addFinancialProduct() {
  //   return this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/insert";
  // }
  //新增金融产品
  static addFinancialProduct() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/insert"
    );
  }
  //编辑金融产品
  static editFinancialProduct() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/update"
    );
  }
  //金融产品详情
  static financialProductDetail() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/detail"
    );
  }

  //删除金融产品
  static deleteFinancialProduct() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybepalfinancedetails/delete"
    );
  }
  //审核管理记录列表
  static getAuditList() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/list";
  }
  //审核管理记录  详情页
  static getAuditDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/detail";
  }
  //审核管理记录  审批
  static auditApply() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/hear";
  }
  //政策汇总信息发布列表获取
  static getInfoList() {
    return this.getDebugUrl() + "blade-cms/cmsweb/currencyList";
  }

  //政策汇总列表获取
  static getInfoList1() {
    return this.getDebugUrl() + "blade-cms/cmsweb/currencyList";
  }

  //违规学员列表
  static getViolationStudentList() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybtrarecordsviolations/list"
    );
  }
  //新增违规学员
  static addViolationStudent() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybtrarecordsviolations/save"
    );
  }
  //违规学员详情
  static violationStudentDetail() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybtrarecordsviolations/detail"
    );
  }

  //退役军人申请金融产品列表
  static getFinancialProductList() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/list";
  }
  //退役军人申请金融产品详情
  static getFinancialProductDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/detail";
  }
  //退役军人申请金融产品  撤销申请(删除)
  static revokeAudit() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/delete";
  }

  //退役军人申请金融产品  重新上传
  static againAudit() {
    return this.getDebugUrl() + "blade-job-startup/sybepalfinanceapply/update";
  }

  //金融服务列表
  static sybfunddetailList() {
    return this.getDebugUrl() + "blade-job-startup/sybfunddetail/list";
  }
  //金融服务详情
  static sybfunddetailDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybfunddetail/detail";
  }
  //首页获取重点企业推荐
  static getImportentFirm() {
    return this.getDebugUrl() + "blade-job-startup/sybauditmechanism/list";
  }
  //首页友情链接
  static getblogroll() {
    return this.getDebugUrl() + "blade-cms/cmsweb/bannerList";
  }
  //首页-教育培训联盟
  static educationTrainingAlliance() {
    return (
      this.getDebugUrl() + "blade-job-startup/sybunioninformation/unionhome"
    );
  }
  //首页-教育培训联盟-详情
  static educationTrainingAllianceDetail() {
    return this.getDebugUrl() + "blade-job-startup/sybunioninformation/detail";
  }
  //文章详情接口
  static getArticleDetail() {
    return this.getDebugUrl() + "blade-cms/cmsweb/currencyDetail";
  }

  //====================个人中心-创业巡诊=================
  //创业专家巡诊申请
  static getSybepalexpertinquiryapplyList() {
    return (
      this.getDebugUrl() + "/blade-job-startup/sybepalexpertinquiryapply/list"
    );
  }
  static getSybepalexpertinquiryapplyDetail() {
    return (
      this.getDebugUrl() + "/blade-job-startup/sybepalexpertinquiryapply/detail"
    );
  }
  //====================个人中心-创业巡检=================

  //====================个人中心-创业服务申请=================
  //创业服务申请
  static getSybepalservicesapplyList() {
    return this.getDebugUrl() + "/blade-job-startup/sybepalservicesapply/list";
  }
  //创业服务详情
  static getSybepalservicesapplyDetail() {
    return (
      this.getDebugUrl() + "/blade-job-startup/sybepalservicesapply/detail"
    );
  }
  static getSybepalservicesapplyDetele() {
    return this.getDebugUrl() + "blade-job-startup/sybepalservicesapply/delete";
  }
  static getSybepalservicesapplyUpdate() {
    return this.getDebugUrl() + "blade-job-startup/sybepalservicesapply/update";
  }
  //职位收藏
  static getJobCollect() {
    return (
      this.getDebugUrl() +
      "blade-job-startup/sybjobinformationapply/page/collectible"
    );
  }
  //====================个人中心-创业巡检=================

  //判断是否认证
  static getApplyStatus() {
    return this.getDebugUrl() + "blade-user/getStatus";
  }

  //获取当前登录用户信息
  static getUserInfo() {
    return this.getDebugUrl() + "blade-user/info";
  }
}
